module.exports = __webpack_public_path__ + "static/media/flyrest-2.540ed4e6.jpg";